import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import { useHistory } from "react-router-dom";
import "react-datepicker2/src/styles/style.css";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import BihamtaTable from "../../Components/BihamtaTable";
import { deleteDocument, searchDocuments, resetDocumentSearchFilters, copyDocument } from "../store/api/DocumentsAPI";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import { exportToExcel, invoiceTypesArray,  keyIsLetterOrNumber, setDialog, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import ModalSelectCostCenter from "../Components/ModalSelectCostCenter";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, Files, List, Printer, Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom } from "@fortawesome/free-solid-svg-icons";
import NewNumberInput from "../../Components/NewNumberInput";
import ModalAddEditChequeFunctions from "../Components/ModalAddEditChequeFunctions";

const SearchDocuments = () => {
    const frmFilters = useRef();
    const history = useHistory();
    // const filterData = useRef({});
    const dateFilters = useRef({});
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const { register, handleSubmit } = useForm();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [popUser, setPopUser] = useState({ show: false });
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [popCostCenter, setPopCostCenter] = useState({ show: false });
    const [modalCheqFunctions, setModalCheqFunctions] = useState({ Show: false });
    const filterState = useSelector(state => state.DocumentReducer.documentsFilter);
    // if (filterState) {
    //     filterData.current = { ...filterState };
    // }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
    }, []);
    function showModalAccLevel3(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            if (filterState) {
                dispatch(resetDocumentSearchFilters({
                    ...filterState,
                    AccountID: data ? data.AccountID : null,
                    AccountCat: data ? data.AccountCat : null,
                    AccountName: data ? data.AccountName : ""
                }));
            }
            //selectAccount(data);
        }
        setPopAccLevel3({ show: true, setAccData: onSetData, value: e.key });
    }
    function showModalCostCenter(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (filterState) {
                dispatch(resetDocumentSearchFilters(
                    {
                        ...filterState,
                        CostCenterID: data ? data.ID : null,
                        CostCenterName: data ? data.CenterName : ""
                    }));
            }
            //selectCostCenter(data);
        }
        setPopCostCenter({
            show: true,
            onSelect: onSelect
        });

    }
    function showCreateBy() {
        const onSelect = (data) => {
            if (filterState) {
                dispatch(resetDocumentSearchFilters(
                    {
                        ...filterState,
                        CreateById: data ? data.ID : null,
                        CreateByName: data ? data.Name : ""
                    }));
            }
            //setCreateBy(data);
        }
        setPopUser({ show: true, selectUserWithName: onSelect });
    }
    function showUpdateBy() {
        const onSelect = (data) => {
            if (filterState) {
                dispatch(resetDocumentSearchFilters(
                    {
                        ...filterState,
                        UpdateById: data ? data.ID : null,
                        UpdateByName: data ? data.Name : ""
                    }));
            }
            //setUpdateBy(data);
        }
        setPopUser({ show: true, selectUserWithName: onSelect });
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "شماره سند", colName: "DocumentNumber", showInMobile: true },
        { colTitle: "تاریخ سند", colName: "PDocumentDate", showInMobile: true },
        { colTitle: "شرح سند", colName: "DocumentDesc", showInMobile: true, colType: "string", maxTextLength: 100 },
        { colTitle: "وضعیت", colName: "PDocumentStatus", showInMobile: false },
        {colTitle:"مبلغ سند", colName:"TotalAmount", colType:"currency"},
        { colTitle: "تاریخ ثبت", colName: "PDocumentCreationDate", showInMobile: false },
        { colTitle: "ثبت کننده", colName: "CreateByName", showInMobile: false },
        { colTitle: "تاریخ ویرایش", colName: "PUpdateDate", showInMobile: false },
        { colTitle: "ویرایش کننده", colName: "UpdateByName", showInMobile: false }
    ];
    function toExcel() {
        const url = "api/DocumentsAPI/SearchDocuments";
        const searchArgs = { ...filterState };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("DocumentList", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        const docDateFrom = document.getElementsByName("DocumentDateFrom")[0];
        if (docDateFrom.value !== "") {
            data.DocumentDateFrom = dateFilters.current.DocumentDateFrom;
        }
        else {
            dateFilters.current.DocumentDateFrom = null;
        }
        const docDateTo = document.getElementsByName("DocumentDateTo")[0];
        if (docDateTo.value !== "") {
            data.DocumentDateTo = dateFilters.current.DocumentDateTo;
        }
        else {
            dateFilters.current.DocumentDateTo = null;
        }
        const creationDateFrom = document.getElementsByName("CreationDateFrom")[0];
        if (creationDateFrom.value !== "") {
            data.CreationDateFrom = dateFilters.current.CreationDateFrom;
        }
        else {
            dateFilters.current.CreationDateFrom = null;
        }
        const creationDateTo = document.getElementsByName("CreationDateTo")[0];
        if (creationDateTo.value !== "") {
            data.CreationDateTo = dateFilters.current.CreationDateTo;
        }
        else {
            dateFilters.current.CreationDateTo = null
        }
        const updateDateFrom = document.getElementsByName("UpdateDateFrom")[0];
        if (updateDateFrom.value !== "") {
            data.UpdateDateFrom = dateFilters.current.UpdateDateFrom;
        }
        else {
            dateFilters.current.UpdateDateFrom = null;
        }
        const updateDateTo = document.getElementsByName("UpdateDateTo")[0];
        if (updateDateTo.value !== "") {
            data.UpdateDateTo = dateFilters.current.UpdateDateTo;
        }
        else {
            dateFilters.current.UpdateDateTo = null;
        }
        data.Skip = 0;
        //filterData.current = { ...data };
        dispatch(searchDocuments(data));

    }
    function rowClick(row) {
        history.push(`/Accounting/AddEditDocument/${row.DocumentID}`);
    }
    function deleteDoc(id) {
        const onDone = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف سند حسابداری");
            }
            dispatch(searchDocuments(filterState))
        }
        return () => deleteDocument(id, onDone);
    }
    function printDoc(item) {
        history.push({
            pathname: `/PrintViewer/AccountingDocument/${item.e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetDocument?documentID=${item.DocumentID}`,
                method: "get"
            }
        });
    }
    // function copyDoc(item) {
    //     const onDone = (res) => {
    //         if (res === "PENDING") {
    //             return;
    //         }
    //         if (res.Error) {
    //             setErrorDialog(dispatch, res.Error, "کپی سند حسابداری");
    //         }
    //         else {
    //             setErrorDialog(dispatch, res.ResultMessage, "کپی سند حسابداری");
    //             history.push(`/Accounting/AddEditDocument/${res.DocumentID}`);
    //         }
    //     }
    //     copyDocument(item.DocumentID, onDone);
    // }
    function showDocAttach(item) {
        const base = window.location.origin;

        const attachType = item.AttachmentType.replaceAll("Formal", "");
        if (invoiceTypesArray.some(i => i.TypeName.toLocaleLowerCase() === attachType.toLocaleLowerCase())) {
            window.open(`${base}/Sale/Invoice/${attachType}/${item.AttachmentID}/${item.AttachmentType.includes("Formal")}`);
        }
        else if (attachType.toLocaleLowerCase() === "install" || attachType.toLocaleLowerCase() === "repair") {
            window.open(`${base}/Services/Service/${item.AttachmentID}/${item.AttachmentType}`)
        }
        else if(attachType?.toLowerCase().contains("cheque") || attachType?.toLowerCase().contains("in_") || attachType?.toLowerCase().contains("out_"))
        {
            setModalCheqFunctions({
                Show: true,
                FunctionID: item.AttachmentID,
                ChequeStatus: item.AttachmentType/*,
                ChequeID: row.ChequeID*/
            })
        }

    }
    function clearFilters() {
        frmFilters.current.reset();
        dateFilters.current = {};
        dispatch(resetDocumentSearchFilters({Take:10, Skip:0}));
        dispatch(searchDocuments({Take:10, Skip:0}));
    }
    const tableRowButtons = [
        {
            title: "نمایش سند", type: "common", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobile
        },
        {
            title: "چاپ سند", tooltip: "چاپ سند", type: "common", className: "group-Btn-smalll btn-primary", onclick: printDoc, icon: <Printer color="#811849" size={18} className="rowBtn" />
        }
        ,
        // {
        //     title: "کپی سند", tooltip: "کپی سند", type: "common", className: "group-Btn-smalll btn-secondary", showCondition: () => !isMobile, onclick: (item) => copyDoc(item), icon: <Files color="green" size={18} className="rowBtn" />
        // },
        {
            title: "حذف سند", type: "delete", className: "group-Btn-smalll btn-danger", showCondition: () => !isMobile, onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف سند',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteDoc(item.DocumentID)
                }))
            }
        },
        {
            title: "پیوست سند", type: "related", className: "group-Btn-smalll btn-info", onclick: (item) => showDocAttach(item), showCondition: (item) => Number(item.AttachmentID) > 0
        }

    ];
    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
            <ModalSelectCostCenter popData={popCostCenter} setPopCostCenter={setPopCostCenter} />
            <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />
            <ModalAddEditChequeFunctions popData={modalCheqFunctions} setPopData={setModalCheqFunctions} />
            <Card>
                <Card.Header className="headerStyle">جستجوی سند حسابداری</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right", minHeight: "45vh" }}>
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={3} className="form-group mt-3">
                                <Row className="rowBorder">
                                    <div className="rowTitle" style={{ fontWeight: "normal", color: "#5c1f9a" }}>شماره سند</div>
                                    <Col md={6} className="mt-1">
                                        <label>از:</label>
                                        <input className="search-input" ref={register()} name="DocumentNumberFrom"
                                            defaultValue={filterState?.DocumentNumberFrom ? filterState.DocumentNumberFrom : ""} />
                                    </Col>
                                    <Col md={6} className="mt-1">
                                        <label>تا :</label>
                                        <input className="search-input" ref={register()} name="DocumentNumberTo"
                                            defaultValue={filterState?.DocumentNumberTo ? filterState.DocumentNumberTo : ""} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} className="form-group mt-3">
                                <Row className="rowBorder">
                                    <div className="rowTitle" style={{ fontWeight: "normal", color: "#5c1f9a" }}>تاریخ سند</div>
                                    <Col md={6} className="mt-1">
                                        <label>از:</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="DocumentDateFrom"
                                            value={filterState?.DocumentDateFrom ? momentJalaali(filterState.DocumentDateFrom.substring(0, 10)) : dateFilters.current.DocumentDateFrom ? momentJalaali(dateFilters.current.DocumentDateFrom) : null}
                                            onChange={val => dateFilters.current.DocumentDateFrom = val.local("en").format("YYYY-MM-DD")} />
                                    </Col>
                                    <Col md={6} className="mt-1">
                                        <label>تا:</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="DocumentDateTo"
                                            value={filterState?.DocumentDateTo ? momentJalaali(filterState.DocumentDateTo.substring(0, 10)) : dateFilters.current.DocumentDateTo ? momentJalaali(dateFilters.current.DocumentDateTo) : null}
                                            onChange={val => dateFilters.current.DocumentDateTo = val.local("en").format("YYYY-MM-DD")} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} className="form-group mt-3">
                                <Row className="rowBorder">
                                    <div className="rowTitle" style={{ fontWeight: "normal", color: "#5c1f9a" }}>تاریخ ایجاد</div>
                                    <Col md={6} className="mt-1">
                                        <label>از:</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateFrom"
                                            value={filterState?.CreationDateFrom ? momentJalaali(filterState.CreationDateFrom.substring(0, 10)) : dateFilters.current.CreationDateFrom ? momentJalaali(dateFilters.current.CreationDateFrom) : null}
                                            onChange={val => dateFilters.current.CreationDateFrom = val.local("en").format("YYYY-MM-DD")} />
                                    </Col>
                                    <Col md={6} className="mt-1">
                                        <label>تا :</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateTo"
                                            value={filterState?.CreationDateTo ? momentJalaali(filterState.CreationDateTo.substring(0, 10)) : dateFilters.current.CreationDateTo ? momentJalaali(dateFilters.current.CreationDateTo) : null}
                                            onChange={val => dateFilters.current.CreationDateTo = val.local("en").format("YYYY-MM-DD")} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} className="form-group mt-3">
                                <Row className="rowBorder">
                                    <div className="rowTitle" style={{ fontWeight: "normal", color: "#5c1f9a" }}>تاریخ ویرایش</div>
                                    <Col md={6} className="mt-1">
                                        <label>از:</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="UpdateDateFrom"
                                            value={filterState?.UpdateDateFrom ? momentJalaali(filterState.UpdateDateFrom.substring(0, 10)) : dateFilters.current.UpdateDateFrom ? momentJalaali(dateFilters.current.UpdateDateFrom) : null}
                                            onChange={val => dateFilters.current.UpdateDateFrom = val.local("en").format("YYYY-MM-DD")} />
                                    </Col>
                                    <Col md={6} className="mt-1">
                                        <label>تا:</label>
                                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="UpdateDateTo"
                                            value={filterState?.UpdateDateTo ? momentJalaali(filterState.UpdateDateTo.substring(0, 10)) : dateFilters.current.UpdateDateTo ? momentJalaali(dateFilters.current.UpdateDateTo) : null}
                                            onChange={val => dateFilters.current.UpdateDateTo = val.local("en").format("YYYY-MM-DD")} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>نوع سند:</label>
                                <select className="search-input" ref={register({})} name="AttachmentType" defaultValue={filterState?.AttachmentType ? filterState.AttachmentType : ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="install,repair">سرویس ها</option>
                                    <option value="Sale,Purchase,ReturnFromSale,ReturnFromPurchase,ReturnFromBorrow,Borrow,OldParts">فاکتورهای انبار</option>
                                    <option value="in_1_RecieveCheque,in_2_PutInAccount,in_3_GiveToCustomer,in_4_Cash,in_5_NotCash,in_6_ReturnAndCustomerPay,in_7_ReturnAndCustomerNotPay,in_8_CustomerReturns">چکهای دریافتی</option>
                                    <option value="out_1_PayCheque,out_2_PassCheque,out_3_CustomerReturns">چکهای پرداختی</option>
                                    <option value="ServiceInvoice">فاکتورهای خدمات</option>
                                    <option value="no_attachment">اسناد بدون ضمیمه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>وضعیت سند:</label>
                                <select className="search-input" ref={register({})} name="DocumentStatus" defaultValue={filterState?.DocumentStatus ? filterState.DocumentStatus : ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="Permanet">دائم</option>
                                    <option value="Temporary">موقت</option>
                                    <option value="Draft">پیش نویس</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>شرح سند:</label>
                                <input type="text" className="search-input" ref={register({})} name="DocumentDesc" defaultValue={filterState?.DocumentDesc ? filterState.DocumentDesc : ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>حساب تفصیلی :</label>
                                <input type="hidden" name="AccountID" readOnly value={filterState?.AccountID ? filterState.AccountID : ""} ref={register({})} />
                                <input type="hidden" name="AccountCat" readOnly value={filterState?.AccountCat ? filterState.AccountCat : ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly ref={register({})} name="AccountName"
                                    value={filterState?.AccountName ? filterState.AccountName : ""} onKeyDown={showModalAccLevel3} />
                                <Button className="btn-input-tiny" style={{ top: "22px", left:"5px" }} onClick={showModalAccLevel3}><List size={18} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>مرکز هزینه :</label>
                                <input type="hidden" name="CostCenterID" value={filterState?.CostCenterID ? filterState.CostCenterID : ""} readOnly ref={register({})} />
                                <input type="text" className="search-input" ref={register({})} name="CostCenterName" value={filterState?.CostCenterName ? filterState.CostCenterName : ""} readOnly onKeyDown={showModalCostCenter} />
                                <Button className="btn-input-tiny" style={{ top: "22px", left:"6px" }} onClick={showModalCostCenter}><List size={18} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>ثبت کننده :</label>
                                <input type="hidden" name="CreateById" readOnly value={filterState?.CreateById ? filterState.CreateById : ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly value={filterState?.CreateByName ? filterState.CreateByName : ""}
                                    name="CreateByName" ref={register({})} onKeyDown={showCreateBy} />
                                <Button className="btn-input-tiny" style={{ top: "22px", left:"6px" }} onClick={showCreateBy}><List size={18} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>ویرایش کننده :</label>
                                <input type="hidden" name="UpdateById" readOnly value={filterState?.UpdateById ? filterState.UpdateById : ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly name="UpdateByName" ref={register({})}
                                    value={filterState?.UpdateByName ? filterState.UpdateByName : ""} onKeyDown={showUpdateBy} />
                                <Button className="btn-input-tiny" style={{ top: "22px", left:"6px" }} onClick={showUpdateBy}><List size={18} /></Button>
                            </Col>
                            <Col md={2} className="form-group" >
                                <label style={{ color: "#5c1f9a" }}>از مبلغ: </label>
                                <NewNumberInput className="search-input!" reff={register({})} inputname="AmountFrom" defaultValue={filterState?.AmountFrom ?? 0}/>
                            </Col>
                            <Col md={2} className="form-group" >
                                <label style={{ color: "#5c1f9a" }}>تا مبلغ: </label>
                                <NewNumberInput  className="search-input!"  reff={register({})} inputname="AmountTo" defaultValue={filterState?.AmountTo ?? 0}/>
                            </Col>                            
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>تعداد در صفحه</label>
                                <select className="search-input" defaultValue={filterState?.Take ? Number(filterState.Take) : 10} name="Take" ref={register({})}>
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label style={{ color: "#5c1f9a" }}>مرتب سازی بر اساس</label>
                                <select className="search-input" name="OrderBy" ref={register({})} defaultValue={filterState?.OrderBy ? filterState.OrderBy : "CreationDate DESC"}>
                                    <option value="DocNumber">شماره سند</option>
                                    <option value="DocNumber DESC">شماره سند-نزولی</option>
                                    <option value="DocDate">تاریخ سند</option>
                                    <option value="DocDate DESC">تاریخ سند-نزولی</option>
                                    <option value="CreationDate">تاریخ ثبت</option>
                                    <option value="CreationDate DESC">تاریخ ثبت-نزولی</option>
                                </select>
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="Submit"><Search size={18} />&nbsp;جستجوی سند</Button>
                    </form>
                    {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" /></div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterState} rowClick={rowClick}
                        searchMethod={(data) => dispatch(searchDocuments(data))} reducerName="DocumentReducer" objectName="documentList" hasPaging={true} />
                </Card.Body>
            </Card>
        </div>)
}
export default SearchDocuments;